import axios from 'axios';

const dev = 'http://127.0.0.1:5001/nfttoolkit-ba61b/us-central1/';
const prod = 'https://us-central1-nfttoolkit-ba61b.cloudfunctions.net/';
const forceProd = true;
const base = process.env.REACT_APP_DEVELOPMENT && !forceProd ? dev : prod;

const loopringBase = 'https://api3.loopring.io/';

// cors proxy for GSMP collection reqs
export const proxyUrl = `${base}api/proxy/`;

// Get tokens of a specific account
export const getDerivedCollections = async (accountId) => {
  if (!accountId) return [];
  const endpoint = `api/account/${accountId}/collectionsFromNFTs`; // Replace with your actual endpoint URL
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

// Get tokens of a specific account
export const getNFTs = async (accountId) => {
  if (!accountId) return [];
  const endpoint = `api/account/${accountId}/nfts`; // Replace with your actual endpoint URL
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

// Get token gated files for a specific account
export const getFiles = async (accountId) => {
  if (!accountId) return [];
  const endpoint = `api/files/account/${accountId}`; // Replace with your actual endpoint URL
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

// Get token gated files for a specific account
export const getFilesForGate = async (gateId) => {
  if (!gateId) return [];
  const endpoint = `api/files/gate/${gateId}`; // Replace with your actual endpoint URL
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

// Get mints of a specific account
export const getMints = async (accountId) => {
  if (!accountId) return [];
  const endpoint = `api/account/${accountId}/mintedNfts`; // Replace with your actual endpoint URL
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

// Get holdings of a specific account
export const getThreads = (data) => {
  const endpoint = 'api/threadRipper-get';
  const params = `url=${data}`;
  const url = `${base}${endpoint}?${params}`;
  return axios.get(url);
};

// post redpacket reveal
export const postRedPacketReveal = (imageFile) => {
  const endpoint = 'redpacketreveal';
  const url = `${base}${endpoint}`;

  // Create a FormData object and append the image file to it
  const formData = new FormData();
  formData.append('image', imageFile);

  // Make a POST request with the FormData object as the request body
  return axios.post(url, formData, {
    responseType: 'blob', // important
    headers: {
      enctype: 'multipart/form-data',
      'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
    },
  });
};

// Get biggest holders for a specific account
export const getWhales = async (accountId) => {
  if (!accountId) return [];
  const endpoint = `api/account/${accountId}/whales`;
  const url = `${base}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};

export const getAccountId = async (owner) => {
  if (!owner) return [];
  const endpoint = `api/v3/account?owner=${owner}`;
  const url = `${loopringBase}${endpoint}`;
  const response = await axios.get(url);
  return response.data;
};
